module.exports = __webpack_public_path__ + "static/img/pro-img0.e92fc88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pro-img0.jpg
// module id = c0aR
// module chunks = 1